import React from "react";
import { v4 as uuidv4 } from "uuid";
import { connect } from "react-redux";
import {
  Checkbox,
  Col,
  Icon,
  Button,
  Row,
  Select,
  Table,
  Tooltip,
  Modal,
} from "antd";
import { withNamespaces } from "react-i18next";
import { Link } from "react-router-dom";

import classes from "./DocumentManagementDashboard.css";

import isAuthenticated from "../../utils/isAuthenticated";
import {
  getDocumentDashboardRequiredStatusGeneralRequest,
  getEtmfDocumentSchemaFilterRequest,
  getEtmfDocumentSchemaRequest,
} from "../../api/requests";
import { logout } from "../../reducers/user/actions";
import { withParams } from "../../utils/url";
import DocumentForm from "../../components/DocumentForm/DocumentForm";
import forEach from "lodash/forEach";
import get from "lodash/get";

const routes = require("../../routes.json");

class RequiredStatusGeneral extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      isLoading: false,
      requiredStatusGeneral: [],
      sites: [],
      onlyMissingFilter: false,
      documentEdit: null,
      etmfSchema: {},
      etmfSchemaLimits: {},
      etmfSchemaFilters: {},
    };
  }

  async componentDidMount() {
    this.getData();
    this.getETMFSchema();
  }

  getETMFSchema = async () => {
    try {
      const { data: etmfSchema } = await getEtmfDocumentSchemaRequest();
      const {
        data: etmfSchemaFilter,
      } = await getEtmfDocumentSchemaFilterRequest(null, {
        filter_by: this.state.filtersBy,
        filter_value: this.state.filtersValue,
        filter_approve:
          this.state.approvedSelected !== null
            ? this.state.approvedSelected
            : null,
      });
      const etmfSchemaLimits = {};

      forEach(get(etmfSchema, "schema"), (category) => {
        forEach(category.sub_categories, (subCategory) => {
          forEach(subCategory.content_types, (contentTypes) => {
            if (
              contentTypes.limit_visibility_types &&
              contentTypes.limit_visibility_types.length > 0
            ) {
              etmfSchemaLimits[contentTypes.code] =
                contentTypes.limit_visibility_types;
            } else if (
              subCategory.limit_visibility_types &&
              subCategory.limit_visibility_types.length > 0
            ) {
              etmfSchemaLimits[contentTypes.code] =
                subCategory.limit_visibility_types;
            } else if (
              category.limit_visibility_types &&
              category.limit_visibility_types.length > 0
            ) {
              etmfSchemaLimits[contentTypes.code] =
                category.limit_visibility_types;
            }
          });
        });
      });

      this.setState({ etmfSchema, etmfSchemaLimits, etmfSchemaFilter });
    } catch (e) {
      console.log(e);
      if (get(e, "response.status") === 401) {
        this.props.logout();
        return;
      }
    }
  };

  getData = async () => {
    this.setState({ isLoading: true });
    try {
      const [requiredStatusGeneral] = await Promise.all([
        getDocumentDashboardRequiredStatusGeneralRequest({
          only_missing: this.state.onlyMissingFilter,
        }),
      ]);
      this.setState({
        requiredStatusGeneral: requiredStatusGeneral.data,
      });
    } catch (e) {
      console.log(e);
    }

    this.setState({ isLoading: false });
  };

  addDocumentWithParams = (documentEdit) => {
    this.setState({ documentEdit });
  };

  onDocumentEditHide = () => {
    this.setState({ documentEdit: null });
  };

  onDocumentEditSubmit = () => {
    this.setState({ documentEdit: null, documentApproveId: null }, () => {
      this.getData();
    });
  };

  render() {
    const {
      isLoading,
      documentEdit,
      etmfSchema,
      etmfSchemaLimits,
      sites,
    } = this.state;

    const columns = [
      {
        dataIndex: "required_in",
        key: "required_in",
        title: this.props.i18n.t("NamespaceDocumentsDashboard:Required in"),
      },
      {
        dataIndex: "primary_category",
        key: "primary_category",
        title: this.props.i18n.t("NamespaceDocumentsDashboard:Primary Category"),
      },
      {
        dataIndex: "sub_category",
        key: "sub_category",
        title: this.props.i18n.t("NamespaceDocumentsDashboard:Sub Category"),
      },
      {
        dataIndex: "content_type",
        key: "content_type",
        title: this.props.i18n.t("NamespaceDocumentsDashboard:Content Type"),
      },
      {
        dataIndex: "status",
        key: "status",
        title: this.props.i18n.t("NamespaceDocumentsDashboard:Status"),
      },
      {
        dataIndex: "number",
        key: "number",
        title: this.props.i18n.t("NamespaceDocumentsDashboard:Number"),
      },
      {
        dataIndex: "actions",
        key: "found_ids",
        width: "200px",
        title: this.props.i18n.t("NamespaceDocumentsDashboard:Actions"),
        render: (val, row) => (
          <div className={classes.actionsTableWrapper}>
            <Button
              type="primary"
              size="small"
              onClick={() => {
                this.addDocumentWithParams({
                  primary_category_code: row.primary_category_code,
                  sub_category_code: row.sub_category_code,
                  content_type_code: row.content_type_code,
                  visibility: row.visibility_type,
                  site_id: row.site_id,
                });
              }}
            >
              {this.props.i18n.t("NamespaceDocumentsDashboard:Add document")}
            </Button>
            &nbsp; &nbsp;
            {row.found_ids.length > 0 && (
              <a
                href={withParams(routes.admin.documentsEditor, {
                  filter_by: "id__in",
                  filter_value: `"${row.found_ids.join(",")}"`,
                })}
                target="_blank"
              >
                <Button type="primary" size="small">
                  {this.props.i18n.t("View")}
                </Button>
              </a>
            )}
          </div>
        ),
      },
    ];

    return (
      <div>
        <h4 className="headline-default">
          {this.props.i18n.t("NamespaceDocumentsDashboard:Central required document status")}
        </h4>

        <div className={classes.actionWrapper}>
          <h5 className="headline-default">{this.props.i18n.t("Filters")}</h5>

          <div className={classes.filterWrapper}>
            <Checkbox
              onChange={() => {
                this.setState(
                  {
                    onlyMissingFilter: !this.state.onlyMissingFilter,
                  },
                  this.getData
                );
              }}
              checked={this.state.onlyMissingFilter}
            >
              {this.props.i18n.t("NamespaceDocumentsDashboard:Only missing")}
            </Checkbox>
          </div>
        </div>

        {isLoading && <Icon type="loading" />}
        {!isLoading && (
          <div className={classes.tableWrapper}>
            <Table
              columns={columns}
              dataSource={this.state.requiredStatusGeneral}
              loading={isLoading}
              pagination={false}
              rowKey={() => uuidv4()}
            />
          </div>
        )}

        <Modal
          visible={!!documentEdit}
          onCancel={this.onDocumentEditHide}
          footer={null}
        >
          {documentEdit && (
            <DocumentForm
              {...documentEdit}
              blockCategories
              etmfSchema={etmfSchema}
              etmfSchemaLimits={etmfSchemaLimits}
              onSubmit={this.onDocumentEditSubmit}
              onCancel={this.onDocumentEditHide}
              isNew={documentEdit && !documentEdit.id}
            />
          )}
        </Modal>
      </div>
    );
  }
}

const mapStateToProps = () => ({});
const mapDispatchToProps = { logout };

export default isAuthenticated(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(withNamespaces()(RequiredStatusGeneral))
);



// WEBPACK FOOTER //
// ./src/containers/DocumentManagementDashboard/RequiredStatusGeneral.js